import React from 'react';
import type Page from '@jira/project-settings__board-settings-card/src/CardCoverPage.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyCard = lazyForPaint<typeof Page>(
	() =>
		import(
			/* webpackChunkName: "async-board-settings-card", jiraSpaEntry: "async-board-settings-card" */ '@atlassian/jira-spa-apps-board-settings-card'
		),
);

const AsyncCard = (): React.JSX.Element => (
	<LazyPage Page={LazyCard} pageId="board-settings-card" shouldShowSpinner={false} />
);

export default AsyncCard;
